<template>
  <div class="logo-container row items-center justify-start">
    <div v-if="!logo" :class="['text-subtitle1', { invisible: !!invisible }]">
      {{ title }}
    </div>
    <img
      :style="logo.style"
      :src="logo.url"
      v-if="logo"
      :class="[{ invisible: !!invisible }]"
    />
  </div>
</template>

<script>
import mixin from "./d-card-mixins";
export default {
  name: "DCardToolbarBrand",
  mixins: [mixin],
  props: {
    logo: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    invisible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-container {
  min-height: 48px;

  img {
    margin: 0 !important;
  }
}
</style>
